module.exports = __webpack_public_path__ + "media/payment_networks/venmo-908dd060.svg";